import { Skeleton } from '@gravity-ui/uikit';
import styles from './styles.module.scss';

export const AdminTableLoaderAdaptive = () => {
	return (
		<div className={styles.admin_table_loader}>
			<div className={styles.admin_table_loader__container}>
				<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
					<Skeleton style={{ maxWidth: '81px', height: '16px', borderRadius: '8px' }} />
					<Skeleton style={{ maxWidth: '81px', height: '16px', borderRadius: '8px' }} />
				</div>
				<Skeleton style={{ maxWidth: '696px', height: '18px' }} />
			</div>
			<div className={styles.admin_table_loader__container}>
				<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
					<Skeleton style={{ maxWidth: '81px', height: '16px', borderRadius: '8px' }} />
					<Skeleton style={{ maxWidth: '81px', height: '16px', borderRadius: '8px' }} />
				</div>
				<Skeleton style={{ maxWidth: '696px', height: '18px' }} />
			</div>
			<div className={styles.admin_table_loader__container}>
				<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
					<Skeleton style={{ maxWidth: '81px', height: '16px', borderRadius: '8px' }} />
					<Skeleton style={{ maxWidth: '81px', height: '16px', borderRadius: '8px' }} />
				</div>
				<Skeleton style={{ maxWidth: '696px', height: '18px' }} />
			</div>
		</div>
	);
};
